<template>
    <div>
        <!-- Access group: Users, Roles, Audit Log -->
        <NavGroup
            v-if="$can(Permission.VIEW_USERS) || $can(Permission.VIEW_ROLES) || $can(Permission.VIEW_AUDITLOG)"
            :flat="flat"
            :label="__('Access')"
        >
            <InertiaLink
                v-if="$can(Permission.VIEW_USERS)"
                :href="route('users.index')"
                class="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
            >
                {{ __('Users') }}
            </InertiaLink>
            <InertiaLink
                v-if="$can(Permission.VIEW_ROLES)"
                :href="route('roles.index')"
                class="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
            >
                {{ __('Roles') }}
            </InertiaLink>
            <InertiaLink
                v-if="$can(Permission.VIEW_AUDITLOG)"
                :href="route('audit-log.index')"
                class="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
            >
                {{ __('Audit Log') }}
            </InertiaLink>
        </NavGroup>

        <!-- Forms group: Forms, Form Groups -->
        <NavGroup v-if="$can(Permission.VIEW_FORMS) || $can(Permission.VIEW_FORMGROUPS)" :flat="flat" :label="__('Forms')">
            <InertiaLink
                v-if="$can(Permission.VIEW_FORMS)"
                :href="route('forms.index')"
                class="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
            >
                {{ __('Forms') }}
            </InertiaLink>
            <InertiaLink
                v-if="$can(Permission.VIEW_FORMGROUPS)"
                :href="route('form-groups.index')"
                class="block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
            >
                {{ __('Form Groups') }}
            </InertiaLink>
        </NavGroup>

        <!-- Remaining top-level items -->
        <InertiaLink v-if="$can(Permission.VIEW_INVITES)" :href="route('invites.index')" :class="itemClass">
            {{ toTitleCase(settings.general.invite_name_plural) }}
        </InertiaLink>
        <InertiaLink v-if="$can(Permission.VIEW_IMPORTS)" :href="route('batch-imports.index')" :class="itemClass">
            {{ __('Import/Export') }}
        </InertiaLink>
        <InertiaLink v-if="$can(Permission.VIEW_FILES)" :href="route('files.index')" :class="itemClass">
            {{ __('Files') }}
        </InertiaLink>
        <InertiaLink v-if="$can(Permission.VIEW_SETTINGS)" :href="route('settings.index')" :class="itemClass">
            {{ __('Settings') }}
        </InertiaLink>
        <InertiaLink v-if="$can(Permission.VIEW_DOCS)" :href="route('docs.index')" :class="itemClass">
            {{ __('Docs') }}
        </InertiaLink>
    </div>
</template>

<script setup lang="ts">
import { Link as InertiaLink, usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

import NavGroup from '@/Components/NavGroup.vue';
import { Permission } from '@/lib/permissions';
import type { AuthenticatedPageProps } from '@/types/inertia';
import { toTitleCase } from '@/util';

const props = defineProps<{
    flat?: boolean;
}>();

const page = usePage<AuthenticatedPageProps>();
const settings = computed(() => page.props.settings);

// In flat (mobile) mode every item is a full-width list row matching the grouped
// links; on desktop the standalone items stay inline in the horizontal nav bar.
const itemClass = computed(() => (props.flat ? 'block px-4 py-2 text-sm text-gray-600 hover:bg-gray-100' : 'px-2 text-sm text-gray-600'));
</script>
